import React from 'react';
import _ from 'lodash';

const { browser } = Mobi2Go.UI;
const className = Mobi2Go.helpers.classNames;

class DateOfBirthPickerForIos extends React.Component {
    render = () => {
        const dob_moment = moment(this.props.date_of_birth);
        const { baseClass } = this.props;
        return (
            <div className={className(baseClass('-dob--date-input-element'))}>
                <input
                    className={className(baseClass('-dob-ios-input'))}
                    min="1900-01-01"
                    max="2000-12-31"
                    type="date"
                    onChange={e => this.props.onChange(e.target.value)}
                    value={this.props.date_of_birth}
                    onFocus={this.props.onFocus}
                />
                <div className={className(baseClass('-dob-input-display'))}>
                    <span
                        className={className(
                            baseClass('-dob-input-display__day')
                        )}
                    >
                        <span
                            className={className(
                                baseClass('-dob-input-display-value')
                            )}
                        >
                            {dob_moment.format('Do')}
                        </span>
                    </span>
                    &nbsp;
                    <span
                        className={className(
                            baseClass('-dob-input-display__month')
                        )}
                    >
                        <span
                            className={className(
                                baseClass('-dob-input-display-value')
                            )}
                        >
                            {dob_moment.format('MMM')}
                        </span>
                    </span>
                    ,&nbsp;
                    <span
                        className={className(
                            baseClass('-dob-input-display__year')
                        )}
                    >
                        <span
                            className={className(
                                baseClass('-dob-input-display-value')
                            )}
                        >
                            {dob_moment.format('YYYY')}
                        </span>
                    </span>
                </div>
            </div>
        );
    };
}

class DateOfBirthPickerForEverythingElse extends React.Component {
    onDayChange = e => {
        const day = e.target.value;
        const dob_moment = moment(this.props.date_of_birth);
        this.props.onChange(dob_moment.date(day).format('YYYY-MM-DD'));
    };

    onMonthChange = e => {
        const month = e.target.value - 1;
        const dob_moment = moment(this.props.date_of_birth);
        this.props.onChange(dob_moment.month(month).format('YYYY-MM-DD'));
    };

    onYearChange = e => {
        const year = e.target.value;
        const dob_moment = moment(this.props.date_of_birth);
        this.props.onChange(dob_moment.year(year).format('YYYY-MM-DD'));
    };

    render = () => {
        const dob_moment = moment(this.props.date_of_birth);
        const { baseClass } = this.props;
        return (
            <div className={className(baseClass('-dob--select-element'))}>
                <div className={className(baseClass('-dob-input-display'))}>
                    <div
                        className={className(
                            baseClass('-dob-input-display__day')
                        )}
                    >
                        <span
                            className={className(
                                baseClass('-dob-input-display-value')
                            )}
                        >
                            {dob_moment.format('Do')}
                        </span>
                        <select
                            className={className(
                                baseClass('-dob-invisible-select')
                            )}
                            type="date"
                            onChange={this.onDayChange}
                            value={dob_moment.format('D')}
                            onFocus={this.props.onFocus}
                        >
                            <optgroup label="Day">
                                {_.map(
                                    _.range(1, dob_moment.daysInMonth() + 1),
                                    day => (
                                        <option key={day} value={day}>
                                            {day}
                                        </option>
                                    )
                                )}
                            </optgroup>
                        </select>
                    </div>
                    &nbsp;
                    <div
                        className={className(
                            baseClass('-dob-input-display__month')
                        )}
                    >
                        <span
                            className={className(
                                baseClass('-dob-input-display-value')
                            )}
                        >
                            {dob_moment.format('MMM')}
                        </span>
                        <select
                            className={className(
                                baseClass('-dob-invisible-select')
                            )}
                            type="date"
                            onChange={this.onMonthChange}
                            value={dob_moment.format('M')}
                            onFocus={this.props.onFocus}
                        >
                            <optgroup label="Month">
                                <option value="1">January</option>
                                <option value="2">February</option>
                                <option value="3">March</option>
                                <option value="4">April</option>
                                <option value="5">May</option>
                                <option value="6">June</option>
                                <option value="7">July</option>
                                <option value="8">August</option>
                                <option value="9">September</option>
                                <option value="10">October</option>
                                <option value="11">November</option>
                                <option value="12">December</option>
                            </optgroup>
                        </select>
                    </div>
                    ,&nbsp;
                    <div
                        className={className(
                            baseClass('-dob-input-display__year')
                        )}
                    >
                        <span
                            className={className(
                                baseClass('-dob-input-display-value')
                            )}
                        >
                            {dob_moment.format('YYYY')}
                        </span>
                        <select
                            className={className(
                                baseClass('-dob-invisible-select')
                            )}
                            type="date"
                            onChange={this.onYearChange}
                            value={dob_moment.format('YYYY')}
                            onFocus={this.props.onFocus}
                        >
                            <optgroup label="Year">
                                {_.map(_.range(1890, 2012).reverse(), year => (
                                    <option key={year} value={year}>
                                        {year}
                                    </option>
                                ))}
                            </optgroup>
                        </select>
                    </div>
                </div>
            </div>
        );
    };
}

export default class DateOfBirthPicker extends React.Component {
    render = () => {
        if (browser.ios) {
            return <DateOfBirthPickerForIos {...this.props} />;
        }

        return <DateOfBirthPickerForEverythingElse {...this.props} />;
    };
}
